export default (n) => {
  return (n / 1).toFixed(1)
}
